import { render, staticRenderFns } from "./FontAwesomePickerModal.vue?vue&type=template&id=648dc860"
import script from "./FontAwesomePickerModal.vue?vue&type=script&lang=js"
export * from "./FontAwesomePickerModal.vue?vue&type=script&lang=js"
import style0 from "./FontAwesomePickerModal.vue?vue&type=style&index=0&id=648dc860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports